





import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ComponentPageOrganizationInfo extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/organization/info/component.vue